import React, { useState } from "react";
import { ReactComponent as BackIc } from "../../../assets/svg/back_arrow.svg";
import { ReactComponent as DownArrowIc } from "../../../assets/svg/down_arrow_ics.svg";

export const ApprovalConfigView = ({ flowData, onBack, onEdit }) => {
    // Default flow data if none provided
    const defaultFlowData = {
        code: "#32342",
        name: "Sample Flow Name",
        module: "Purchase Order",
        type: "Sequential",
        levelsCount: 3,
        status: "Active",
        createdAt: "23 May 2025 05:30 PM",
        createdBy: "Ragu Ram",
        updatedAt: "23 May 2025 05:30 PM",
        updatedBy: "Ragu Ram",
        levels: [
            { id: 1, name: "Level 1", type: "Specific user based", persons: ["Sasi Kumar", "Senthilkumar"], canReject: true, commentsMandatory: false },
            { id: 2, name: "Level 1", type: "Specific user based", persons: ["Sasi Kumar", "Senthilkumar"], canReject: true, commentsMandatory: false },
            { id: 3, name: "Level 1", type: "Specific user based", persons: ["Sasi Kumar", "Senthilkumar"], canReject: true, commentsMandatory: false }
        ]
    };

    const data = flowData || defaultFlowData;

    return (
        <div className="approval-config-container p-0" style={{ width: "100%" }}>
            {/* Top Header Card */}
            <div className="bg-white mb-3"
                style={{ borderRadius: "12px", boxShadow: "0px 2px 4px 0px #0000000A", width: "100%", overflow: "hidden" }}>
                
                {/* Main Row */}
                <div className="d-flex align-items-center justify-content-between p-3">
                    <div className="d-flex align-items-center gap-3">
                        <div className="cursor-pointer d-flex align-items-center" onClick={onBack}>
                            <BackIc width={20} height={20} />
                        </div>
                        {/* Gear inside square inside circle */}
                        <div className="d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                                width: "48px",
                                height: "48px",
                                backgroundColor: "#F3F4F6",
                            }}>
                            <div className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: "28px",
                                    height: "28px",
                                    backgroundColor: "#4F46E5",
                                    borderRadius: "8px",
                                    color: "white"
                                }}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="3"></circle>
                                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                                </svg>
                            </div>
                        </div>
                        {/* Title and Code */}
                        <div className="d-flex flex-column">
                            <h5 className="m-0 fw-700 fs-16 header-title" style={{ color: "#1F2937", lineHeight: "1.2" }}>{data.name}</h5>
                            <span className="fs-12 fw-500 mt-1" style={{ color: "#6B7280" }}>
                                Code : <span style={{ color: "#4F46E5", fontWeight: "600" }}>{data.code}</span>
                            </span>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {/* Status badge active */}
                        <div className="px-3 py-1 rounded-pill d-flex align-items-center gap-2 cursor-pointer"
                            style={{ backgroundColor: "#DCFCE7", color: "#166534", fontSize: "13px", fontWeight: "600", border: "none" }}>
                            <div style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#22C55E" }}></div>
                            {data.status}
                            <DownArrowIc width={10} height={10} fill="#166534" className="ms-1" />
                        </div>

                        {/* Edit button */}
                        <button className="btn fw-700 fs-14 px-4 text-white d-flex align-items-center gap-2"
                            style={{ backgroundColor: "#4F46E5", borderRadius: "20px", height: "36px" }}
                            onClick={onEdit}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 20h9"></path>
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                            </svg>
                            Edit
                        </button>

                        {/* Three dots menu */}
                        <div className="cursor-pointer d-flex align-items-center justify-content-center border rounded-circle"
                            style={{ width: "36px", height: "36px", borderColor: "#E5E7EB" }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4B5563" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="1"></circle>
                                <circle cx="12" cy="5" r="1"></circle>
                                <circle cx="12" cy="19" r="1"></circle>
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Bottom Row: Created and Updated timestamps */}
                <div className="d-flex align-items-center gap-4 px-3 py-2 text-muted" style={{ fontSize: "12px" }}>
                    <div className="d-flex align-items-center">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-muted">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <span>Created at <span className="fw-500 text-dark">{data.createdAt}</span> by <span className="fw-500 text-dark">{data.createdBy}</span></span>
                    </div>
                    <div style={{ width: "1px", height: "14px", backgroundColor: "#E5E7EB" }}></div>
                    <div className="d-flex align-items-center">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-muted">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <span>Last updated at <span className="fw-500 text-dark">{data.updatedAt}</span> by <span className="fw-500 text-dark">{data.updatedBy}</span></span>
                    </div>
                </div>
            </div>

            {/* Card 1: Details Section */}
            <div className="bg-white p-4 mb-3"
                style={{ borderRadius: "16px", boxShadow: "0px 2px 4px 0px #0000000A", width: "100%" }}>
                <div className="details-section" style={{ width: "100%", maxWidth: "948px" }}>
                    <h6 className="form-section-title mb-4" style={{ fontWeight: "700", fontSize: "16px", color: "#1F2937" }}>
                        Approval configuration flow details :-
                    </h6>

                    <div className="d-flex flex-column gap-3">
                        {/* Module */}
                        <div className="d-flex align-items-center" style={{ height: "32px" }}>
                            <div className="label-width" style={{ width: "120px", color: "#6B7280", fontWeight: "500", fontSize: "14px" }}>Module</div>
                            <div className="fw-700 textcolor fs-14" style={{ color: "#1F2937" }}>{data.module}</div>
                        </div>

                        {/* Type */}
                        <div className="d-flex align-items-center" style={{ height: "32px" }}>
                            <div className="label-width" style={{ width: "120px", color: "#6B7280", fontWeight: "500", fontSize: "14px" }}>Type</div>
                            <div className="fw-700 textcolor fs-14" style={{ color: "#1F2937" }}>{data.type}</div>
                        </div>

                        {/* Levels */}
                        <div className="d-flex align-items-center" style={{ height: "32px" }}>
                            <div className="label-width" style={{ width: "120px", color: "#6B7280", fontWeight: "500", fontSize: "14px" }}>Levels</div>
                            <div className="fw-700 textcolor fs-14" style={{ color: "#1F2937" }}>{data.levelsCount}</div>
                        </div>

                        {/* Status */}
                        <div className="d-flex align-items-center" style={{ height: "32px" }}>
                            <div className="label-width" style={{ width: "120px", color: "#6B7280", fontWeight: "500", fontSize: "14px" }}>Status</div>
                            <div className="px-3 py-1 rounded-pill d-flex align-items-center gap-2"
                                style={{ backgroundColor: "#DCFCE7", color: "#166534", fontSize: "12px", fontWeight: "600", border: "none", width: "fit-content" }}>
                                <div style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#22C55E" }}></div>
                                {data.status}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card 2: Configuration flow */}
            <div className="bg-white p-4 mb-3"
                style={{ borderRadius: "16px", boxShadow: "0px 2px 4px 0px #0000000A", width: "100%" }}>
                <h6 className="form-section-title mb-3" style={{ fontWeight: "700", fontSize: "16px", color: "#1F2937" }}>
                    Configuration Flow
                </h6>

                {/* Inner Grey Card Container */}
                <div className="p-4" style={{ backgroundColor: "#F8F9FA", borderRadius: "16px", width: "100%" }}>
                    <p className="text-uppercase mb-3" style={{
                        fontFamily: "'Lexend Deca', sans-serif",
                        fontWeight: "600",
                        fontSize: "13px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        color: "#8790A1"
                    }}>
                        CONFIGURE APPROVAL FLOW :-
                    </p>

                    {/* White Table Box */}
                    <div className="bg-white" style={{ borderRadius: "12px", border: "1px solid #E5E7EB", overflow: "hidden", width: "100%" }}>
                        {/* Table Header */}
                        <div className="approval-flow-grid-row px-3" 
                            style={{ 
                                backgroundColor: "#FFFFFF", 
                                height: "42px", 
                                borderTopLeftRadius: "12px", 
                                borderTopRightRadius: "12px",
                                borderTop: "1px solid #EBEBEB",
                                display: "grid",
                                gridTemplateColumns: "18fr 20fr 34fr 14fr 14fr",
                                columnGap: "16px",
                                alignItems: "center"
                            }}>
                            <div className="text-start text-uppercase" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", fontWeight: "600", color: "#8790A1" }}>Level Name</div>
                            <div className="text-start text-uppercase" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", fontWeight: "600", color: "#8790A1" }}>Approval Type</div>
                            <div className="text-start text-uppercase" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", fontWeight: "600", color: "#8790A1" }}>Approval Person(s)</div>
                            <div className="text-start text-uppercase" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", fontWeight: "600", color: "#8790A1" }}>Can Reject</div>
                            <div className="text-start text-uppercase" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", fontWeight: "600", color: "#8790A1" }}>Mandatory Comments</div>
                        </div>

                        <div style={{ height: "1px", backgroundColor: "#E5E7EB", width: "100%" }}></div>

                        {/* Table Rows */}
                        {data.levels.map((level, idx) => (
                            <div key={level.id || idx} className="approval-flow-grid-row bg-white"
                                style={{
                                    height: "40px",
                                    paddingLeft: "16px",
                                    paddingRight: "16px",
                                    borderBottom: "0.6px solid #D4DDE7"
                                }}>
                                <div className="fs-13 fw-600 textcolor">{level.name || `Level ${idx + 1}`}</div>
                                <div className="fs-13 fw-500 textcolor">{level.type}</div>
                                <div>
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        {level.persons && level.persons.length > 0 ? (
                                            level.persons.map((person, pIdx) => (
                                                <div key={pIdx} className="custom-pill px-3 py-1 textPurple"
                                                    style={{ backgroundColor: "#EEF2FF", borderRadius: "6px", fontSize: "12px", fontWeight: "600" }}>
                                                    {person}
                                                </div>
                                            ))
                                        ) : (
                                            <span className="text-muted fs-13">No persons selected</span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    {level.canReject ? (
                                        <div className="d-flex align-items-center gap-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" fill="#10B981" />
                                                <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span className="fw-600 fs-13" style={{ color: "#1F2937" }}>Yes</span>
                                        </div>
                                    ) : (
                                        <div className="d-flex align-items-center gap-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" fill="#EF4444" />
                                                <path d="M8 8L16 16M16 8L8 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span className="fw-600 fs-13" style={{ color: "#1F2937" }}>No</span>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    {level.commentsMandatory ? (
                                        <div className="d-flex align-items-center gap-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" fill="#10B981" />
                                                <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span className="fw-600 fs-13" style={{ color: "#1F2937" }}>Yes</span>
                                        </div>
                                    ) : (
                                        <div className="d-flex align-items-center gap-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" fill="#EF4444" />
                                                <path d="M8 8L16 16M16 8L8 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <span className="fw-600 fs-13" style={{ color: "#1F2937" }}>No</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@300;400;500;600;700&display=swap');

                .approval-config-container {
                    font-family: 'Lexend Deca', sans-serif !important;
                    width: 100% !important;
                    max-width: 100% !important;
                }

                .main-outer-card {
                    width: 100% !important;
                    box-sizing: border-box !important;
                }

                .approval-config-container .header-title {
                    font-family: 'Lexend Deca', sans-serif !important;
                    color: #111827;
                }

                .approval-config-container .form-section-title {
                    font-family: 'Lexend Deca', sans-serif !important;
                    font-weight: 600 !important;
                    font-size: 16px !important;
                    line-height: 100% !important;
                    color: #212129 !important;
                }

                /* Grid layout matching specs perfectly */
                .approval-flow-grid-row {
                    display: grid !important;
                    grid-template-columns: 18fr 20fr 34fr 14fr 14fr !important;
                    column-gap: 16px !important;
                    align-items: center !important;
                    width: 100% !important;
                }

                .textPurple {
                    color: #4F46E5 !important;
                }

                .textcolor { color: #1F2937; }
                .textGrey { color: #6B7280; }
                `}
            </style>
        </div>
    );
};
